export default __webpack_public_path__ + "static/media/232.f2672eb1.gif";